module.exports = __webpack_public_path__ + "static/media/miami-bg-2.30d00c3f.png";